import { DataTable } from '@app/components/data-table/data-table';
import { DataTableToolbar } from '@app/components/data-table/data-table-toolbar';
import { useDataTable } from '@app/components/data-table/hooks/use-data-table';
import { DataTableProps } from '@app/components/data-table/types/data-table';
import CreateTransportForm from '@app/components/product-form/create-ppt-forms/create-transport-form';
import useSimpleDialog from '@app/hooks/use-simple-dialog';
import { Button } from '@shared/components/ui/button';
import { useToast } from '@shared/components/ui/use-toast';
import { useGetTransportColumns } from './transport-table.columns';

interface TransportTableProps extends DataTableProps<any> {
  includeCreateButton?: boolean;
}

export default function TransportTable({
  data,
  refetch,
  includeCreateButton = true,
  isLoading,
  isFetchedAfterMount,
  isPreviousData,
  status,
}: TransportTableProps) {
  const { toast } = useToast();

  const {
    showSimpleDialog: showCreateTransportDialog,
    SimpleDialogComponent: CreateTransportDialog,
    closeSimpleDialog: closeCreateTransportDialog,
  } = useSimpleDialog();

  const { table } = useDataTable({
    columns: useGetTransportColumns(),
    data: data || [],
    initialState: {
      columnVisibility: {
        uuid: false,
      },
    },
  });

  return (
    <>
      <DataTable
        table={table}
        isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
        tableLoading={!data && status === 'loading'}
        className="bg-gray-00"
      >
        <DataTableToolbar table={table}>
          {includeCreateButton && (
            <Button size="sm" onClick={() => showCreateTransportDialog()}>
              Create
            </Button>
          )}
        </DataTableToolbar>
      </DataTable>
      {CreateTransportDialog({
        header: 'Add transport step',
        content: (
          <CreateTransportForm
            onTransportCreated={() => {
              closeCreateTransportDialog();
              toast({
                title: 'Transport step created successfully',
                variant: 'success',
              });
              refetch && refetch();
            }}
          />
        ),
      })}
    </>
  );
}
